<script setup>
import LoadingSpinnerPage from "@/components/molecules/loading-spinner/loading-spinner-page";
import { useTrackingPage } from "@/mixins/tracking/all-pages";

const app = useNuxtApp();
const route = useRoute();

useHead({
  meta: [
    {
      name: "robots",
      content: "noindex"
    }
  ]
});

const { trackPage } = useTrackingPage();

onBeforeMount(() => {
  navigateTo("/", {
    redirectCode: 301,
    replace: true
  });
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.recettes);
  app.$partenairesEvents.dispatch("page-loaded", route.path, true);
});
</script>

<template>
  <div class="u-bgcolor-white">
    <div class="miamRecettes">
      <LoadingSpinnerPage />
    </div>
  </div>
</template>
